'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _Popover = require('../Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _icon = require('../../models/icon');

var _icon2 = _interopRequireDefault(_icon);

var _icons = require('../../models/icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popoverVisible: false,
      selectedIcon: null
    }, _this.onButtonClick = function () {
      _this.setState({
        popoverVisible: !_this.state.popoverVisible
      });
    }, _this.onClickOutside = function () {
      if (_this.state.popoverVisible) {
        // Avoid unnecessary setState
        _this.setState({
          popoverVisible: false
        });
      }
    }, _this.onIconClick = function (icon) {
      _this.setState({
        selectedIcon: icon,
        popoverVisible: false
      });
      _this.props.onIconSelected(icon);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          defaultIcon = _props.defaultIcon,
          icons = _props.icons;
      var _state = this.state,
          popoverVisible = _state.popoverVisible,
          selectedIcon = _state.selectedIcon;


      return _react2.default.createElement(
        Container,
        null,
        _react2.default.createElement(_Button2.default, {
          defaultIcon: defaultIcon,
          icon: selectedIcon,
          onClick: this.onButtonClick
        }),
        popoverVisible && _react2.default.createElement(_Popover2.default, {
          icons: icons,
          onClickOutside: this.onClickOutside,
          onIconClick: this.onIconClick,
          rowLength: this.props.rowLength,
          visibleRows: this.props.visibleRows,
          iconSize: this.props.iconSize
        })
      );
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  defaultIcon: _icon2.default.isRequired,
  icons: _icons2.default.isRequired,
  onIconSelected: _propTypes2.default.func,
  rowLength: _propTypes2.default.number,
  visibleRows: _propTypes2.default.number,
  iconSize: _propTypes2.default.number
};
_class.defaultProps = {
  onIconSelected: function onIconSelected() {},
  rowLength: 7,
  visibleRows: 10,
  iconSize: 40
};
exports.default = _class;